export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant01-mobile-de.0b73b020.png";